var _g, _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], t.indexOf(o) >= 0 || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.indexOf(n) >= 0) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgWq(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 45,
    height: 45,
    viewBox: "0 0 45 45",
    fill: "white",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_d_4569_10037)"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M22.5 6.25C20.9812 6.25 19.75 7.48122 19.75 9C19.75 10.2071 20.5278 11.2326 21.6095 11.6026L19.285 22.8376L15.3028 12.4224C16.1644 11.9581 16.75 11.0474 16.75 10C16.75 8.48122 15.5188 7.25 14 7.25C12.4812 7.25 11.25 8.48122 11.25 10C11.25 11.3595 12.2365 12.4886 13.5327 12.7105L13.3019 23.5565L7.7828 15.0939C8.37466 14.5895 8.75 13.8386 8.75 13C8.75 11.4812 7.51878 10.25 6 10.25C4.48122 10.25 3.25 11.4812 3.25 13C3.25 14.5139 4.47323 15.742 5.98522 15.75L8.25064 27.0771C8.26003 27.6426 8.37334 28.1112 8.57918 28.5229C8.78956 28.9437 9.07585 29.2615 9.34467 29.5303C9.43862 29.6243 9.53141 29.7138 9.62285 29.802L9.62308 29.8022C10.0632 30.2268 10.4721 30.6212 10.8292 31.3354C10.8431 31.3632 10.8587 31.3902 10.876 31.416C11.0063 31.6115 11.12 31.774 11.2155 31.9098L11.2346 31.937L11.2346 31.937L11.2348 31.9373C11.3231 32.0629 11.3887 32.1561 11.4426 32.2386C11.5536 32.4083 11.5666 32.4616 11.5727 32.4983C11.5824 32.5567 11.5859 32.6725 11.5336 32.9861C11.4971 33.2056 11.4424 33.4745 11.3686 33.8381L11.3221 34.0671C10.5641 34.6727 10.2709 35.4113 10.1933 36.032C10.1571 36.3211 10.1681 36.5775 10.1921 36.7759C9.90557 37.1275 9.72109 37.4878 9.63639 37.8548C9.52533 38.3361 9.60091 38.7644 9.74814 39.1079C9.89111 39.4415 10.0987 39.6906 10.2587 39.8506C10.3406 39.9325 10.4152 39.9962 10.4718 40.0412C10.5003 40.0639 10.5246 40.0821 10.5436 40.0959C10.5532 40.1028 10.5614 40.1086 10.5681 40.1132L10.5772 40.1195L10.5809 40.122L10.5825 40.123L10.584 40.124C10.6749 40.1847 10.778 40.2247 10.886 40.2413C17.4615 41.2529 27.5385 41.2529 34.114 40.2413C34.222 40.2247 34.3251 40.1847 34.416 40.124L34 39.5C34.416 40.124 34.4175 40.123 34.4175 40.123L34.4191 40.122L34.4228 40.1195L34.4319 40.1132C34.4386 40.1086 34.4468 40.1028 34.4564 40.0959C34.4754 40.0821 34.4997 40.0639 34.5282 40.0412C34.5848 39.9962 34.6594 39.9325 34.7413 39.8506C34.9013 39.6906 35.1089 39.4415 35.2519 39.1079C35.3991 38.7644 35.4747 38.3361 35.3636 37.8548C35.2789 37.4878 35.0944 37.1275 34.8079 36.7759C34.8319 36.5775 34.8428 36.3211 34.8067 36.032C34.7291 35.4113 34.4359 34.6727 33.6779 34.0671L33.6314 33.8381C33.5576 33.4745 33.5029 33.2056 33.4664 32.9861C33.4141 32.6725 33.4176 32.5567 33.4273 32.4983C33.4334 32.4616 33.4464 32.4083 33.5574 32.2386C33.6114 32.156 33.677 32.0628 33.7654 31.937L33.7845 31.9098C33.88 31.774 33.9937 31.6115 34.124 31.416C34.1413 31.3902 34.1569 31.3632 34.1708 31.3354C34.5279 30.6212 34.9368 30.2268 35.3769 29.8022L35.3772 29.8019C35.4686 29.7137 35.5614 29.6243 35.6553 29.5303C35.9241 29.2615 36.2104 28.9437 36.4208 28.5229C36.6266 28.1114 36.7399 27.6431 36.7494 27.0779L39.0149 15.75C40.5268 15.7419 41.75 14.5138 41.75 13C41.75 11.4812 40.5188 10.25 39 10.25C37.4812 10.25 36.25 11.4812 36.25 13C36.25 13.8386 36.6254 14.5896 37.2173 15.094L31.6983 23.5565L31.4675 12.7104C32.7636 12.4885 33.75 11.3594 33.75 10C33.75 8.48122 32.5188 7.25 31 7.25C29.4812 7.25 28.25 8.48122 28.25 10C28.25 11.0475 28.8356 11.9582 29.6973 12.4225L25.7151 22.8376L23.3906 11.6026C24.4723 11.2325 25.25 10.2071 25.25 9C25.25 7.48122 24.0188 6.25 22.5 6.25Z",
    fill: "#2F3233"
  }))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M9 26C17.5 24.5 30 24.5 36 26L38.5 13.5L31 25L30.7 10.9L25.5 24.5L22.5 10L19.5 24.5L14.3 10.9L14 25L6.5 13.5L9 26Z",
    stroke: "#141414",
    strokeWidth: 1.5,
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M9 26C9 28 10.5 28 11.5 30C12.5 31.5 12.5 31 12 33.5C10.5 34.5 11 36 11 36C9.5 37.5 11 38.5 11 38.5C17.5 39.5 27.5 39.5 34 38.5C34 38.5 35.5 37.5 34 36C34 36 34.5 34.5 33 33.5C32.5 31 32.5 31.5 33.5 30C34.5 28 36 28 36 26C27.5 24.5 17.5 24.5 9 26Z",
    stroke: "#141414",
    strokeWidth: 1.5,
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M11.5 30C15 29 30 29 33.5 30",
    stroke: "#141414",
    strokeWidth: 1.5,
    strokeLinejoin: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M12 33.5C18 32.5 27 32.5 33 33.5",
    stroke: "#141414",
    strokeWidth: 1.5,
    strokeLinejoin: "round"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M6 14C7.10457 14 8 13.1046 8 12C8 10.8954 7.10457 10 6 10C4.89543 10 4 10.8954 4 12C4 13.1046 4.89543 14 6 14Z",
    stroke: "#141414",
    strokeWidth: 1.5,
    strokeLinejoin: "round"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M14 11C15.1046 11 16 10.1046 16 9C16 7.89543 15.1046 7 14 7C12.8954 7 12 7.89543 12 9C12 10.1046 12.8954 11 14 11Z",
    stroke: "#141414",
    strokeWidth: 1.5,
    strokeLinejoin: "round"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M22.5 10C23.6046 10 24.5 9.10457 24.5 8C24.5 6.89543 23.6046 6 22.5 6C21.3954 6 20.5 6.89543 20.5 8C20.5 9.10457 21.3954 10 22.5 10Z",
    stroke: "#141414",
    strokeWidth: 1.5,
    strokeLinejoin: "round"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M31 11C32.1046 11 33 10.1046 33 9C33 7.89543 32.1046 7 31 7C29.8954 7 29 7.89543 29 9C29 10.1046 29.8954 11 31 11Z",
    stroke: "#141414",
    strokeWidth: 1.5,
    strokeLinejoin: "round"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M39 14C40.1046 14 41 13.1046 41 12C41 10.8954 40.1046 10 39 10C37.8954 10 37 10.8954 37 12C37 13.1046 37.8954 14 39 14Z",
    stroke: "#141414",
    strokeWidth: 1.5,
    strokeLinejoin: "round"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_d_4569_10037",
    x: 2.25,
    y: 6.25,
    width: 40.5,
    height: 36.75,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 1
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 0.5
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.25 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_4569_10037"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_4569_10037",
    result: "shape"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgWq);
export default __webpack_public_path__ + "static/media/wq.20de3b994cc45963fa3949120bba1820.svg";
export { ForwardRef as ReactComponent };